import styled from 'styled-components';
import { TypographyStyles, media, spacing } from '@storefront/lib-global/stylings';

export const Container = styled.div`
  > ul {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  button:disabled {
    cursor: unset;
  }

  @media ${media.greaterThan('lg')} {
    > ul {
      grid-template-columns: repeat(5, 1fr);
    }
  }
`;
export const Title = styled.h2`
  ${TypographyStyles.Headings.H5}
  margin: 0 0 ${spacing.XXXS};

  @media ${media.greaterThan('lg')} {
    margin: 0 0 ${spacing.XXS};
  }
`;
